import React from "react";
import ErrorHandlerContext from "../../hooks/userErrorHandler/ErrorHandlerContext";

let setError = (title: string, error: any, action?: () => void) => {};

const ErrorHandlerProvider = (props: any) => {
  if (props.callback) {
    setError = props.callback;
  }

  return (
    <ErrorHandlerContext.Provider value={setError}>
      {props.children}
    </ErrorHandlerContext.Provider>
  );
};

export default ErrorHandlerProvider;
